export const isAdminRole = (role) => ['Admin', 'CityAdmin', 'SuperAdmin'].includes(role);
export const isCentralRole = (role) => ['Purchase', 'Admin', 'CityAdmin', 'SuperAdmin'].includes(role);
// Read-only: can view Silat / Silat Commitments dashboards and export reports,
// but must never see edit/approve controls.
export const isSilatViewerRole = (role) => role === 'Silat Viewer';
